import {createSlice} from '@reduxjs/toolkit';

import {
  builderGetOrder,
  builderGetOrderDetails,
  builderGetOrders,
  builderGetOrdersReportNew,
  builderGetOrdersReportTrip,
  builderGetOrdersReportTripTracking
} from './reducer';

const initialState: any = {
  gettingOrderDetails: false,
  getOrderDetailsError: '',
  orderDetails: {},
  orderDetailsList: [],
  orders: {pagination: {total_page: 0, page: 1, page_size: 10}, orders: []},
  order: {},
  orderReports: {},
  filters: {updated: false},
  loading: 0,
  ordersReportTrip: {},
  ordersReportTripTracking: {}
};

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get order details
    builderGetOrderDetails(builder);

    builderGetOrders(builder);
    builderGetOrder(builder);
    builderGetOrdersReportNew(builder);
    builderGetOrdersReportTrip(builder);
    builderGetOrdersReportTripTracking(builder);
  }
});

export default orderSlice.reducer;
